import * as yup from 'yup';

export const quoteNoteSchema = () =>
  yup.object().shape({
    content: yup.string().nullable(),
  });
